import { globalState } from '@codeleap/store'
import { ProfileFeatures } from './types'

export type ProfileStore = {
  features: ProfileFeatures[]
}

const initialState = {
  features: []
}

export const state = globalState<ProfileStore>(initialState, {
  persistKey: 'profileStore',
})

export function setFeatures(features: ProfileFeatures[]) {
  state.set({ features })
}

export function useHasFeature(feature: ProfileFeatures) {
  const features = state.use(state => state.features)
  return features?.includes?.(feature)
}

export function hasFeature(feature: ProfileFeatures) {
  const features = state.get().features
  return features?.includes?.(feature)
}